import RouteNames from '@/configuration/router/names.routes';
import { AuthMethods } from '@/models/auth-methods';

/**
 * Utility class for handling authentication-related logic.
 */
export class AuthUtils {
  private static readonly loginRoutes: Record<AuthMethods, string> = {
    [AuthMethods.Spain]: RouteNames.SpainAuth,
    [AuthMethods.FranceMock]: RouteNames.FranceAuth
    // Extend with additional methods as needed
  };

  /**
   * Returns the corresponding login route name based on the authentication method.
   *
   * @param authMethod - The current authentication method.
   * @returns The name of the login route.
   */
  public static getLoginRouteName(authMethod: AuthMethods): string {
    return this.loginRoutes[authMethod] || RouteNames.FranceAuth;
  }
}
